import { axiosUtil } from "../../utils/axios_util";

const loginApi = {
  //获取用户登录信息
  loginUserInfo(data?: string) {
    return axiosUtil({
      url: "/login/user_info",
      method: "get",
      data,
    });
  },
  logout() {
    return axiosUtil({
      url: "/logout",
      method: "post",
    });
  },
  // *sso登录
  ssologin(data: { url: string; state: string }) {
    return axiosUtil({
      url: `/login/oauth2/code/logto?code=${data.url}&state=${data.state}`,
      method: "post",
      data,
    });
  },

  //获取菜单展示列表
  menuList() {
    return axiosUtil({
      url: "/base/get_menu_list",
      method: "post",
    });
  },

  //JWT 授权登录
  jwtLogin(data: any) {
    return axiosUtil({
      url: `/login/jwt`,
      method: "get",
      headers: { Authorization: "Bearer " + data },
    });
  },

  //获取门户平台首页展示数据
  getHomePageData() {
    return axiosUtil({
      url: "/base/get_home_page_data",
      method: "post",
    });
  },

  //根据字典类型获取字典数据
  getByType(data: string) {
    return axiosUtil({
      url: "/dictionary_manager/getByType",
      method: "get",
      params: {
        dictionaryType: data,
      },
    });
  },
};

export default loginApi;
